{
  "more": "Plus d’éléments"
}
